import type { Resource } from '../../';
export const header_utilBar_account: Resource = {"default":"Account"};
